import React from 'react';
import { useSelector } from 'react-redux';
import { ProfilePage as UIProfilePage } from 'pisaka-ui';
import { useSubscription } from '../subscription/useSubscription';
import { AppStateTypes } from '../../store/appStateTypes';

export const ProfilePage: React.FC = () => {
  const { user } = useSelector((state: AppStateTypes) => state.auth) || {};
  const {
    currentSubscription,
    hasSubscription,
    isLoading,
    fetchCurrentSubscription,
    cancelSubscription,
  } = useSubscription();

  const handleCancelSubscription = async (subscriptionId: string) => {
    await cancelSubscription(subscriptionId);
  };

  return (
    <UIProfilePage
      user={user}
      currentSubscription={currentSubscription}
      hasSubscription={hasSubscription}
      isLoading={isLoading}
      onFetchCurrentSubscription={fetchCurrentSubscription}
      onCancelSubscription={handleCancelSubscription}
    />
  );
};